import { Box, colors } from "@mui/material";
import { Link } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import ShareIcon from "@mui/icons-material/Share";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const AdmnistrationWeb = () => {
  return (
    <Box>
      <div className="list-unstyled d-flex flex-row center">
        <div className="p-2">
          <Link to="/add-groupe" style={{ color: "#00a652" }}>
            {" "}
            <GroupWorkIcon /> Groupe
          </Link>
        </div>
        <div className="p-2">
          <Link
            to="/add-formulaire"
            className="ml-2 d-block"
            style={{ color: "#00a652" }}
          >
            {" "}
            <AttachFileIcon /> Formulaire de déclaration
          </Link>
        </div>
        <div className="m-2">
          <Link
            to="/admin-article"
            className="ml-2 d-block"
            style={{ color: "#00a652" }}
          >
            <ArticleIcon /> Articles
          </Link>
        </div>

        <div className="m-2">
          <Link
            to="/admin-slides"
            className="ml-2 d-block"
            style={{ color: "#00a652" }}
          >
            <SlideshowIcon /> Vidéo
          </Link>
        </div>
        <div className="m-2">
          <Link
            to="/annonce"
            className="ml-2 d-block"
            style={{ color: "#00a652" }}
          >
            <ShareIcon /> Annonce
          </Link>
        </div>
      </div>
    </Box>
  );
};
export default AdmnistrationWeb;
